var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-message"},_vm._l((_vm.array),function(alert,index){return _c('div',{key:index,staticClass:"alert-content"},[_c('v-alert',{attrs:{"type":alert.type}},[_vm._v(" "+_vm._s(alert.text)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }